import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Company } from 'src/app/core/interfaces/company.interface';
import { environment } from 'src/environments/environment';

const FISCAL_YEAR_STORAGE_KEY = 'company_default_fiscal_year';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  /** True when a valid fiscal year exists in localStorage (skip Company/default request) */
  hasValidFiscalYearInStorage(): boolean {
    try {
      const stored = localStorage.getItem(FISCAL_YEAR_STORAGE_KEY);
      if (stored == null || stored === '') return false;
      const num = Number(stored);
      return !isNaN(num) && num > 0;
    } catch {
      return false;
    }
  }

  /** Store fiscal year in localStorage when response has a valid value */
  setFiscalYearInStorage(value: number | string | null | undefined): void {
    try {
      if (value == null || value === '') {
        localStorage.removeItem(FISCAL_YEAR_STORAGE_KEY);
        return;
      }
      const num = Number(value);
      if (!isNaN(num) && num > 0) {
        localStorage.setItem(FISCAL_YEAR_STORAGE_KEY, String(num));
      } else {
        localStorage.removeItem(FISCAL_YEAR_STORAGE_KEY);
      }
    } catch {
      // ignore
    }
  }

  getCompany(id: number): Observable<Company> {
    return this.http.get<Company>(`${this.baseUrl + '/Structure/Company'}` + '/' + id);
  }

  getDefault(isCachable = false) {
    const header = isCachable ? { headers: { 'X-Use-Cache': 'true' } } : {};
    return this.http.get<any>(`${this.baseUrl + '/Structure/Company/default'}`, header);
  }

  listCompanies(pageNumber = 1, pageSize = 10, term = ''): Observable<any> {
    const data = {
      term,
      advancedSearch: {
        fields: [],
        term: '',
      },
      advancedFilter: [],
      pageNumber,
      pageSize,
      orderBy: [],
    };

    return this.http.post(`${this.baseUrl + '/Structure/Company/list'}`, data);
  }

  createCompany(data: Company): Observable<any> {
    return this.http.post(`${this.baseUrl + '/Structure/Company'}`, data);
  }

  updateCompany(data: Company): Observable<any> {
    return this.http.put(`${this.baseUrl + '/Structure/Company'}`, data);
  }

  deleteCompany(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl + '/Structure/Company'}` + '/' + id);
  }
}
